import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

import { DatabaseModule } from './database/database.module';
import { FrillWidgetComponent } from './frill-widget/frill-widget.component';
import { AuthService } from './services/auth.service';

@NgModule({
  declarations: [FrillWidgetComponent],
  imports: [CommonModule, DatabaseModule],
  exports: [FrillWidgetComponent],
  providers: [AuthService, DeviceDetectorService],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
    }
  }
}
